import React, { useCallback, useContext } from 'react';
import cc from 'classcat';
import classes from './FilterButton.module.scss';
import { ReactComponent as FilterIcon } from '../../../../../../assets/icons/filter.svg';
import { ReactComponent as FilterActiveIcon } from '../../../../../../assets/icons/filter-active.svg';
import { AppTableContext } from '../../../AppTableContext';
import { WMButton, WMButtonVariant } from '@walkme/wm-ui';
import { WMTableColumnShape } from '../../../WMTable/WMTable';

const FilterButton = ({
    isColumnFilterActive,
    column,
    setEditFilter,
    isFilterBoxOpen
}: {
    column: WMTableColumnShape;
    isColumnFilterActive?: (column: WMTableColumnShape) => boolean;
    setEditFilter: $TSFixMe;
    isFilterBoxOpen: boolean;
}) => {
    const { tableDataTestid } = useContext(AppTableContext);
    const isColumnFilterActiveValue = isColumnFilterActive?.(column) ?? false;

    const onClick = useCallback(
        (event: any) => {
            event.stopPropagation();

            setEditFilter({
                anchorEl: event.currentTarget,
                dataKey: column.dataKey,
                title: column.title,
                renderFilterItem: column.renderFilterItem,
                type: column.filterMetaData?.type
            });
        },
        [column.dataKey, column.filterMetaData?.type, column.renderFilterItem, column.title, setEditFilter]
    );

    return (
        <WMButton
            className={cc([
                classes.columnFunnelButton,
                {
                    [classes.open]: isFilterBoxOpen,
                    [classes.active]: isColumnFilterActiveValue
                }
            ])}
            variant={WMButtonVariant.Text}
            isIconButton
            iconComponent={isColumnFilterActiveValue ? <FilterActiveIcon /> : <FilterIcon />}
            data-testid={`${tableDataTestid}-${column.dataKey}-filter-trigger`}
            onClick={onClick}
        />
    );
};

export default FilterButton;
